import React, {ReactElement} from 'react';
import {Formik, FormikHelpers} from 'formik';
import { UsedVehicle } from '../../../typing/used-inventory';
import { fieldsConfiguration, FormConfiguration, formStatus, ServerConfig, stringMap } from '../../../typing/forms';
import { getDCCFormValidationSchema } from './helpers';
import { getSubmitHandlerFunction } from './submit-function';

interface FormikCustomProps {
  setFormState: (state: formStatus) => void;
  children: ReactElement;
  fieldsConfiguration?: fieldsConfiguration;
  vehicle?: UsedVehicle,
  formConfiguration: FormConfiguration
  serverConfig: ServerConfig;
}



const FormikCustom: React.FC<FormikCustomProps> = props => {
  const {
    children,
    fieldsConfiguration = {},
    vehicle, formConfiguration,
    setFormState,
    serverConfig
  } = props;


  const validationSchema = getDCCFormValidationSchema(
    fieldsConfiguration
  );

  const resetFormState = (
    state: formStatus,
    _: stringMap,
    props: FormikHelpers<stringMap>
  ) => {
    if (state === 'submitting') return setFormState(state);
    if (state === 'success') props.resetForm();
    setFormState(state);
  };

  const submitHandler = getSubmitHandlerFunction(
    resetFormState,
    serverConfig.faServicesUrl,
    formConfiguration.requestType,
    formConfiguration.paramsType,
    formConfiguration,
    serverConfig.serviceConfigsServiceConfig,
    serverConfig.mockIds,
    undefined,
    vehicle,
    serverConfig.trackingManager,
  );

  return (
    <Formik
      initialValues={fieldsConfiguration || {}}
      initialStatus={false}
      onSubmit={submitHandler}
      validateOnMount={true}
      validationSchema={validationSchema}
      isInitialValid={false}
      enableReinitialize
    >
      {children}
    </Formik>
  );
};

export default FormikCustom;
